import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggerBaseQuery } from "../common.js";
import { LIST_TAG } from "../utils.js";
import { vnextXCardApiBaseQuery, VNEXT_TAGS, xCardScorecardApiBaseQuery, SCORECARD_TAGS } from "./common.js";
const xCardApi = createApi({
  reducerPath: "exp_xcard_rtkquery",
  baseQuery: getLoggerBaseQuery(vnextXCardApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(VNEXT_TAGS)]
});
const xCardScorecardApi = createApi({
  reducerPath: "exp_xcardui_rtkquery",
  baseQuery: getLoggerBaseQuery(xCardScorecardApiBaseQuery),
  endpoints: () => ({}),
  tagTypes: [LIST_TAG, ...Object.values(SCORECARD_TAGS)]
});
export {
  xCardApi,
  xCardScorecardApi
};
//# sourceMappingURL=api.js.map
